<template>
    <div>
        <div class="assess-form pt-3 pb-3">
            <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>

            <div class="card border-header">
                <div class="card-body">
                    <h3 class="text-center"><b>{{ data.name }}</b></h3>
                    <small>{{ data.description }}</small>

                    <form :class="'mt-3'+(validated ? ' was-validated':'')">
                        <div class="row">
                            <div class="col-sm-12 input-group-lg">
                                <label class="m-0"><b>ชื่อ-สกุล<span class="text-red">*</span></b></label>
                                <input type="text" :class="'form-control '+(validated ? 'is-invalid':'')" id="customerName" v-model="customerName" v-on:keyup.enter="nextPlease('phone')" placeholder="ชื่อ-สกุล" autocomplete="off" required>
                                <div v-if="customerName==''" class="text-left invalid-feedback">กรุณากรอกชื่อ-สกุล</div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-12 input-group-lg">
                                <label class="m-0"><b>เบอร์โทรศัพท์<span class="text-red">*</span></b></label>
                                <input type="tel" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" :class="'form-control '+(validated ? 'is-invalid':'')" id="phone" v-model="phone" maxlength="10" placeholder="เบอร์โทรศัพท์" autocomplete="off" required />
                                <div v-if="phone==''" class="text-left invalid-feedback">กรุณากรอกเบอร์โทรศัพท์</div>
                            </div>
                        </div>
                    </form>
                    
                </div>
            </div>

            <div v-for="(itQ, idQ) in data.listQuestion" :key="idQ" class="card mt-2">
                <div class="card-body p-3 pl-4 pr-4">
                    <div class="row pb-3">
                        <div class="col-12">
                            <label class="m-0"><b>{{ itQ.name }} <span v-if="itQ.request" class="text-danger">*</span></b></label>
                        </div>
                        <div class="col-12">
                            <small>{{ itQ.description }}</small>
                        </div>
                    </div>

                    <div class="row">
                        <div v-if="itQ.type.id!='option'" class="col-12">
                            <div v-for="(itC, idC) in itQ.listChoice" :key="idC" class="form-check pb-2">
                                <input class="form-check-input" :type="itQ.type.id" :name="itQ.type.id" :id="itQ.type.id+idC" :value="itQ.type.id+idC">
                                <label class="form-check-label pl-2" :for="itQ.type.id+idC"> {{ itC.name }}</label>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <select class="form-control">
                                <option value="" disabled>เลือก...</option>
                                <option v-for="(itC, idC) in itQ.listChoice" :key="idC" :value="itQ.type.id+idC">{{ itC.name }}</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>

            <div class="card mt-2">
                <div class="card-body p-3">
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-purple btn-block float-right">ส่งข้อมูล</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p class="text-secondary">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> ข้อมูลของท่านจะถูกเก็บเป็นความลับ
        </p>
        
    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';
export default {
    data(){
        return {
            show: false,
            data: null,
            customerName: '',
            phone: '',
            validated: false,
        }
    },

    created(){
        this.data = this.$route.query;
        this.data.listQuestion = JSON.parse(this.$route.query.listQuestion);
    },

    watch: {

    },

    methods:{
        nextPlease(id) {
            document.getElementById(id).focus();
        },
        
    }
}
</script>

<style scoped>
    .border-header {
        border-top: 10px solid rgb(103 58 183) !important;
    }
</style>